// extracted by mini-css-extract-plugin
module.exports = {"Container":"MarketplaceItemReturnsData_Container__2AQlO"};